import script from "./AppTableWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTableWidget.vue?vue&type=script&setup=true&lang=js"

import "./AppTableWidget.vue?vue&type=style&index=0&id=35ca1a1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35ca1a1c"]])

export default __exports__